/** Code to accesories product **/

$(document).ready(function () {
  const selectorColorOption =
    'div[data-product-handle="soli-shade-wall"] div[data-option-name="color"] .pg__option__value.selected';
  const selectorBundleVariants =
    'div[data-product-handle="soli-shade-wall"] div[data-option-name="bundle & save"] .pg__option__value';
  const color = $(selectorColorOption).attr("title")?.split(" ").slice(-1)[0];

  $(selectorBundleVariants).each(function () {
    const title = $(this).attr("title");

    if (!title.includes(color)) {
      $(this).addClass("hide");a
    }
  });
  
  $('.product-add-variants-container .variant__item').click(function() {
    if ($(this).hasClass('active')) return;

    $('.product-add-variants-container .variant__item').removeClass('active')
    $(this).addClass('active')
  })

  /** New product page slider - click events */

  // $('.product-new-slider-second .product-item-block.buzzfeed-icon').on('click', function(){
  //   window.open('https://www.buzzfeed.com/bykitstone/products-thatll-make-camping-easier-an#139116923', '_blank');
  // })
  // $('.product-new-slider-second .product-item-block.car-and-driver-icon').on('click', function(){
  //   window.open('https://www.caranddriver.com/car-accessories/g45037858/tailgating-essentials', '_blank');
  // })
  // $('.product-new-slider-second .product-item-block.outdoorlife-icon').on('click', function(){
  //   window.open('https://www.outdoorlife.com/gear/best-canopy-tent/', '_blank');
  // })
  // $('.product-new-slider-second .product-item-block.rv-icon').on('click', function(){
  //   window.open('https://www.rv.com/gear-accessories/fathers-day-20224-25-gifts-for-rving-and-outdoorsy-dads#attachment_68862', '_blank');
  // })
});

/** Code to hide thumb images in product page **/

const hideThumbImage = (optionSelected, firstLogin = false) => {
  const allFirstImage = $(`.pg__thumb[data-alt-info="first"]`)

  if (firstLogin && allFirstImage?.length > 0) {
    $(".pg__thumbs .pg__thumb").addClass("hidden");
    $(`.pg__thumb[data-alt-info="first"]`).removeClass("hidden");
    return;
  }

  const colorValue = $(optionSelected).closest("[data-option-name='color']").length
      ? $(optionSelected).data("value")
      : $("[data-option-name='color'] .pg__option__value.selected").data(
          "value"
        );
  const sizeValue = $(optionSelected).closest("[data-option-name='size']").length
    ? $(optionSelected).data("value")
    : $("[data-option-name='size'] .pg__option__value.selected").data(
        "value"
      );

  let altText = `${colorValue}`

  if (sizeValue) {
    altText+= ` / ${sizeValue}`
  }

  if (altText) {
    $(".pg__thumbs .pg__thumb").addClass("hidden");
    $(`.pg__thumb[data-alt-info="${altText}"]`).removeClass("hidden");
    $(`.pg__thumb[data-alt-info="all"]`).removeClass("hidden");
    $(".product-template-section .pg__mains.pg__mains--slider").removeClass(
      "show-limited-tag"
    );

    if (altText.toLowerCase().includes("chili red")) {
      $(".product-template-section .pg__mains.pg__mains--slider").addClass(
        "show-limited-tag"
      );
    }
  }
};

const hideImageWhitColorAndSize = (colorValue, sizeValue) => {
  console.log({colorValue, sizeValue })
  const dataForIdImage = `${colorValue}/${sizeValue}`;
  $(".prop_image_product").addClass("hidden");
  $(`.prop_image_product[data-id-image="${dataForIdImage}"]`).removeClass(
    "hidden"
  );
};

const changeVariantTextShipping = () => {
  setTimeout(() => {
    $('.cc-custom-product-banner-price .extra-text .variant-text').addClass('hide')
    const variantSelected = $('[data-option-name="size"] .pg__option__value.selected').attr('title')
    
    if(!!variantSelected && variantSelected === '10 ft') {
      $('.cc-custom-product-banner-price .extra-text .variant-text.10ft').removeClass('hide')
    }
    if(!!variantSelected && variantSelected === '12 ft') {
      $('.cc-custom-product-banner-price .extra-text .variant-text.12ft').removeClass('hide')
    }   
  }, 300)
}

$(document).on(
  "click",
  "[data-option-name='color'] .pg__option__value, [data-option-name='size'] .pg__option__value",
  function (e, fromMainSlider) {
    e.preventDefault();
    if ($(this).hasClass("selected")) {
      return;
    }

    hideThumbImage(this);
  }
);

$(document).on(
  "click",
  "[data-option-name='color'] .pg__option__value, [data-option-name='size'] .pg__option__value",
  function (e, fromMainSlider) {
    e.preventDefault();
    if ($(this).hasClass("selected")) {
      return;
    }

    const colorValue = $(this).closest("[data-option-name='color']").length
      ? $(this).data("value")
      : $("[data-option-name='color'] .pg__option__value.selected").data(
          "value"
        );
    const sizeValue = $(this).closest("[data-option-name='size']").length
      ? $(this).data("value")
      : $("[data-option-name='size'] .pg__option__value.selected").data(
          "value"
        );

    hideImageWhitColorAndSize(colorValue, sizeValue);
    changeVariantTextShipping()

    $(
      `.variant-text>span[data-color="${colorValue}"][data-size="${sizeValue}"]`
    )
      .show()
      .siblings()
      .hide();
  }
);

$(document).ready(function () {
  const selectedColorValue = $(
    '[data-option-name="color"] .pg__option__value.selected'
  ).data("value");
  const selectedSizeValue = $(
    '[data-option-name="size"] .pg__option__value.selected'
  ).data("value");

  const params = new URLSearchParams(window.location.search);

  changeVariantTextShipping()
  hideThumbImage($('[data-option-name="color"] .pg__option__value.selected'), !params.has('variant'));
  hideImageWhitColorAndSize(selectedColorValue, selectedSizeValue);

  if($('.custom-product-new')?.length) {
    $(".size-selected-circle").text(selectedColorValue);
    $(".product-name > p").text(
      `${$('[data-option-name="size"] .pg__option__value.selected').data("value")} Canopy`
    );
    return;
  }

  $(".size-selected-circle").text(
    $('[data-option-name="size"] .pg__option__value.selected').data("value")
  );

});

$(document).on(
  "click",
  "[data-option-name='size'] .pg__option__value",
  function (e, fromMainSlider) {
    
    setTimeout(() => {
      if ($(this).hasClass("hide")) return;

      if($('.custom-product-new')?.length) {
        $(".product-name > p").text(
          `${$('[data-option-name="size"] .pg__option__value.selected').data("value")} Canopy`
        );
        return;
      }

      $(".size-selected-circle").text($(this).data("value"));
    }, 100);
  }
);


$(document).on(
  "click",
  "[data-option-name='color'] .pg__option__value, [data-option-name='size'] .pg__option__value,[data-option-name='bundle & save'] .pg__option__value",
  function (e, fromMainSlider) {
    e.preventDefault();
    if ($(this).hasClass("selected")) {
      return;
    }

    const colorValue = $(this).closest("[data-option-name='color']").length
      ? $(this).data("value")
      : $("[data-option-name='color'] .pg__option__value.selected").data(
          "value"
        );
    const sizeValue = $(this).closest("[data-option-name='size']").length
      ? $(this).data("value")
      : $("[data-option-name='size'] .pg__option__value.selected").data(
          "value"
        );
    const bundleValue = $(this).closest("[data-option-name='bundle & save']")
      .length
      ? $(this).data("value")
      : $(
          "[data-option-name='bundle & save'] .pg__option__value.selected"
        ).data("value");


    if (colorValue === undefined) {
      $(
        `.variant-text>span[data-bundle-save="${bundleValue}"][data-size="${sizeValue}"]`
      )
        .show()
        .siblings()
        .hide();
    } else if (bundleValue === undefined) {
      $(
        `.variant-text>span[data-color="${colorValue}"][data-size="${sizeValue}"]`
      )
        .show()
        .siblings()
        .hide();
    } else {
      if (
        $(this).data("value") == "Cool Grey" ||
        $(this).data("value") == "Heat Wave Orange" ||
        $(this).data("value") == "Ultra Marine Blue" ||
        $(this).data("value") == "Sage" ||
        $(this).data("value") == "Chili Red"
      ) {
        var bvalue = bundleValue;
        bvalue = bvalue
          .toString()
          .split(" ")
          .reverse()
          .slice(1)
          .reverse()
          .join(" ");
        if ($(this).data("value") == "Cool Grey") {
          bvalue = bvalue + " Grey";
        } else if ($(this).data("value") == "Heat Wave Orange") {
          bvalue = bvalue + " Orange";
        } else if ($(this).data("value") == "Ultra Marine Blue") {
          bvalue = bvalue + " Blue";
        } else if ($(this).data("value") == "Sage") {
          bvalue = bvalue + " Sage";
        } else if ($(this).data("value") == "Chili Red") {
          bvalue = bvalue + " Chili Red";
        }
        $(
          `.variant-text>span[data-color="${colorValue}"][data-size="${sizeValue}"][data-bundle-save="${bvalue}"]`
        )
          .show()
          .siblings()
          .hide();
      } else {
        $(
          `.variant-text>span[data-color="${colorValue}"][data-size="${sizeValue}"][data-bundle-save="${bundleValue}"]`
        )
          .show()
          .siblings()
          .hide();
      }
    }

    if($('.custom-product-new')?.length) {
      $(".size-selected-circle").text(colorValue);
      return;
    }
  }
);



/* 4PAY LOGIC */

/* 4PAY LOGIC */

// Updates hidden variant input in the product form
function updateVariantInput(variantId) {
  const variantInput = document.querySelector(`#${product_form_id} input[name="id"]`);
  if (variantInput) {
    variantInput.value = variantId;
  }
}

// Refresh Shop Pay Installments
function refreshShopPayInstallments() {
  const container = document.querySelector('#shop-pay-installments [data-shopify="payment-terms"]');
  if (container && typeof Shopify !== "undefined" && Shopify.PaymentTerms) {
    Shopify.PaymentTerms.init(container);
  }
}

// Hook into variant change events
$(document).on(
  "click",
  "[data-option-name='color'] .pg__option__value, [data-option-name='size'] .pg__option__value, [data-option-name='bundle & save'] .pg__option__value",
  function () {
    setTimeout(() => {
      // 1. Get the currently selected options from your swatches
      const selectedOptions = [];
      document.querySelectorAll('.pg__option__value.selected').forEach(el => {
        selectedOptions.push(el.textContent.trim());
      });

      // 2. Find matching variant
      const productVariants = window.meta.product.variants; // depends on your theme exposing variants
      const matched = productVariants.find(v => {
        return v?.options?.every((opt, i) => opt === selectedOptions[i]);
      });

      if (matched) {
        // 3. Update hidden input with new variant id
        updateVariantInput(matched.id);

        // 4. Refresh Shop Pay widget
        refreshShopPayInstallments();
      }
    }, 300);
  }
);
